import { useMatches } from "@tanstack/react-router";

export const usePage = () => {
  const matches = useMatches();
  const pathname = matches[matches.length - 1]?.pathname || "/";

  return pathname.substring(1).split("/");
};
